var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table-page-wrapper',{attrs:{"title":_vm.getTitle,"settings-title":"Список доступов","error-text":"Список доступов не загружен","columns":_vm.columns,"filters":_vm.filters,"table-options":_vm.approvalsTable,"create-form":_vm.createApprovalForm,"download-options":_vm.downloadOptions},on:{"download":_vm.getExcel}})
}
var staticRenderFns = []

export { render, staticRenderFns }